import React from 'react';

export const Aside = () => (
    <aside className="aside-menu">
        {/*Aside Menu*/}
    </aside>
);
